import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { aiContentSubNav } from "@/lib/navigationItems";
import { useAuth } from "@/contexts/AuthContext";

export const Route = createFileRoute("/portal/ai-content")({
  component: AIContentLayout,
});

function AIContentLayout() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const isPlatformAdmin = user?.is_admin === true;

  useEffect(() => {
    if (!isLoading && !isPlatformAdmin) {
      navigate({ to: "/portal" });
    }
  }, [isLoading, isPlatformAdmin, navigate]);

  if (isLoading || !isPlatformAdmin) {
    return null;
  }

  return (
    <div className="space-y-4">
      <ProductSubNav items={aiContentSubNav} />
      <Outlet />
    </div>
  );
}
